import { Component,OnInit,ViewChild } from '@angular/core';
import { NavController, NavParams,Refresher,LoadingController,ToastController,Content,AlertController,ModalController } from 'ionic-angular';
import { InspecionarLoteNovoPage } from '../inspecionar-lote-novo/inspecionar-lote-novo';
import { Api } from '../../providers/api/api';
import { LoteDAO } from '../../daos/lote-dao';
import { Grupo } from '../../entities/grupo';
import { Usuario } from '../../entities/usuario';
import { DTOObterLote } from '../../dto/dtoObterLote';
import { RecebeLote } from '../../entities/recebe-lote';
import { DefeitoLote} from '../../entities/defeito-lote';


import _ from 'lodash';



@Component({
  selector: 'page-inspecionar-lote-home',
  templateUrl: 'inspecionar-lote-home.html',
})
export class InspecionarLoteHomePage implements OnInit {
  @ViewChild('content') content: Content;
  private _idsDosGruposSelecionados: number[] = [];
  public usuario: Usuario;
  public obterLotes: DTOObterLote[] = [];
  public lotesAgrupados: { grupo: Grupo, obterLotes: DTOObterLote[] }[] = []; 
  public lotesAgrupadosRaiz: { grupo: Grupo, obterLotes: DTOObterLote[] }[] = [];
  public grupos: Grupo[] = [];
  public loteReceber: RecebeLote = new RecebeLote();

  defeitoLoteRetrabalho: DefeitoLote[];
  defeitoLote2Qualidade: DefeitoLote[];
  searchTerm: string; 
  

  constructor(public navCtrl: NavController, private _modalCtrl: ModalController,
    private _loteDAO: LoteDAO,
    private _toastCtrl: ToastController,
    private _loadingCtrl: LoadingController,
    private _alertCtrl: AlertController,
    private _api: Api,
    public _navParams: NavParams) {    
    this.usuario = _navParams.get('usuario');
  }

  ngOnInit(): void {
    this.listarLotes(); 
  }

  carregarCalculo(){
    this.obterLotes.forEach(obterlote =>{  
      obterlote.QtdeTotDefeitoRetrabalho = 0;  
      obterlote.QtdeTotDefeitoSegQualidade = 0;  
      if (obterlote.DefeitoLote !== null){
        this.defeitoLoteRetrabalho = obterlote.DefeitoLote.filter(a => a.Tipo == 'R');  
        this.defeitoLote2Qualidade = obterlote.DefeitoLote.filter(a => a.Tipo == 'S'); 
        obterlote.QtdeTotDefeitoRetrabalho = this.calQtdeTotDefeito(this.defeitoLoteRetrabalho,'R');
        obterlote.QtdeTotDefeitoRetrabalhoCritico = this.calQtdeTotDefeitoCritico(this.defeitoLoteRetrabalho,'R');

        obterlote.QtdeTotDefeitoSegQualidade =this.calQtdeTotDefeito(this.defeitoLote2Qualidade,'S');        
        obterlote.QtdeTotDefeitoSegQualidadeCritico =this.calQtdeTotDefeitoCritico(this.defeitoLote2Qualidade,'S');
      }

    });

    
  }



  calQtdeTotDefeito(lst: DefeitoLote[], tipo: string):number{    
    let soma = 0;
    if (tipo == 'R'){
      lst.forEach( defeitoLote => {
        soma += defeitoLote.Qtde;
      });
    }else if (tipo == 'S'){
      lst.forEach( defeitoLote => {
        soma += defeitoLote.Qtde;
      });
    }  
    return soma;    
  }

  calQtdeTotDefeitoCritico(lst: DefeitoLote[], tipo: string):number{    
    let soma = 0;
    if (tipo == 'R'){
      lst.forEach( defeitoLote => {
        if (defeitoLote.DefeitoTipo.Critico) soma += defeitoLote.Qtde;
      });
    }else if (tipo == 'S'){
      lst.forEach( defeitoLote => {
        if (defeitoLote.DefeitoTipo.Critico) soma += defeitoLote.Qtde;
      });
    }  
    return soma;    
  }

  private _obterLote(idEmpresa: number, perfil: String): Promise<DTOObterLote[]> {
    return new Promise((resolve, reject) => {
      this._api.get(`LoteRecebido/ListaLoteEmpresa/${idEmpresa}/${perfil}`).subscribe(response =>         
        resolve(JSON.parse(response._body)), reject);               
  
    });
  }

  public listarLotes(refresher?: Refresher): void {
    let load = this._loadingCtrl.create({ content: 'Obtendo lotes...' });
    if (!refresher)
        load.present();

    this.grupos = [];
    this._obterLote(this.usuario.Empresa.Id, this.usuario.Perfil).then(obterLotes => {
          this.lotesAgrupadosRaiz = [];
        this.lotesAgrupados = [];        
        //obterLotes = obterLotes.filter(item => _.isEqual(item.RecebeLote.Usuario.Id, this.usuario.Id));        
        this.obterLotes = obterLotes;
        this.carregarCalculo();   
        //console.log(this.obterLotes);
        
        _.uniqBy(this.obterLotes.map(obterLotes => obterLotes.Grupo), 'Id').forEach(grupo => {
            this.grupos.push(grupo);
            let agrupamento = { grupo: grupo, obterLotes: this.obterLotes.filter(a => _.isEqual(a.Grupo.Id, grupo.Id)) };
            this.lotesAgrupadosRaiz.push(agrupamento);
            this.lotesAgrupados.push(agrupamento);
        });
        if (!refresher) load.dismiss(); else refresher.complete();
    }).catch(error => {
        if (!refresher) load.dismiss(); else refresher.complete();
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao tentar obter lotes. Tente novamente!'+error,
            duration: 3000
        }).present();
    });
  }
  

  public filtros(): void {
    let alert = this._alertCtrl.create({ title: 'Filtro por Grupo', subTitle: 'Selecione grupos de costura para filtrar' });

    this.grupos.forEach(grupo => {
        alert.addInput({
            type: 'checkbox', label: grupo.Descricao, value: grupo.Id.toString(), checked: _.includes(this._idsDosGruposSelecionados, grupo.Id)
        });
    });

    alert.addButton('Cancelar');
    alert.addButton({
        text: 'Ok',
        handler: data => {
            data = data.map(Math.floor);
            if (!_.isEqual(this._idsDosGruposSelecionados, data)) {
                this._idsDosGruposSelecionados = data;
                this._filtrarCategorias();
            }
        }
    });

    alert.present();
  }
  

  private _filtrarCategorias() {
    let load = this._loadingCtrl.create({ content: 'Atualizando listagem...' });

    if (this._idsDosGruposSelecionados.length > 0) {
        load.present();
        this.content.scrollToTop().then(() => {
            this.lotesAgrupados = [];

            this._idsDosGruposSelecionados.forEach(idGrupo => {
                this.lotesAgrupados = _.union(this.lotesAgrupados, this.lotesAgrupadosRaiz.filter(a => a.grupo.Id === idGrupo));
            });

            load.dismiss();
        });
    } else if (!_.isEqual(this.lotesAgrupados, this.lotesAgrupadosRaiz)) {
        load.present();

        this.content.scrollToTop().then(() => {
            this.lotesAgrupados = this.lotesAgrupadosRaiz;
            load.dismiss();
        });
    }
  }

  pushPage(infoLote: DTOObterLote) {
    let modal = this._modalCtrl.create(InspecionarLoteNovoPage, {dtoObterLote: infoLote,usuario: this.usuario});

    modal.onDidDismiss(cadastrou => {
        if (cadastrou)
        this.listarLotes();
    });

    modal.present();

    //this.navCtrl.push(InspecionarLoteNovoPage, {
    //id: "123",
    //name: "Carl" 
    //});
  }

  public liberarLote(dtoObterLote: DTOObterLote): void {
    this.loteReceber.Id= dtoObterLote.RecebeLote.Id;
    this.loteReceber.NumLote = dtoObterLote.RecebeLote.NumLote;
    this.loteReceber.Usuario = this.usuario;
    this.loteReceber.Empresa = this.usuario.Empresa;  

    this._loteDAO.autorizar(this.loteReceber).then(() => {
        this.listarLotes();
    }).catch(error => {
        console.info(error)
        this._toastCtrl.create({
            message: 'Ocorreu um erro ao liberar lote .',
            duration: 3000
        }).present();
    });
  }

  
  public estornarLote(dtoObterLote: DTOObterLote) {
    this._alertCtrl.create({
      title: 'Têm certeza que deseja estornar o lote?',
      subTitle: `Após a confirmação, o lote ${dtoObterLote.RecebeLote.NumLote} será estornado.`,
      inputs: [
          {
              name: 'motivo',
              placeholder: 'Motivo...'
          },
      ],
      buttons: [
          {
              text: 'Não',
              role: 'destructive'
          },
          { 
              text: 'Sim',
              handler: (data) => {
                dtoObterLote.Motivo = data.motivo;
                dtoObterLote.EstornarLote = false;
                dtoObterLote.CodInspecao = this.usuario.Id;

                  this._loteDAO.estornoLote(dtoObterLote,this.usuario.Id ).then(() => {
                      this.listarLotes();
                  }).catch(error => {
                      console.info(error);
                      this._toastCtrl.create({
                          message: 'Ocorreu um erro ao tentar estornar o lote. Tente novamente!',
                          duration: 3000
                      }).present();
                  });
              }
          }
      ]
    }).present();

  }

  public visualizarInspecao(dtoObterLote: DTOObterLote): void {
      if (dtoObterLote.ViewInspecao == undefined)
        dtoObterLote.ViewInspecao = true;
      else if (dtoObterLote.ViewInspecao)
        dtoObterLote.ViewInspecao = false;
      else dtoObterLote.ViewInspecao = true ;
      
  }


}



// WEBPACK FOOTER //
// ./src/pages/inspecionar-lote-home/inspecionar-lote-home.ts